import { useMediaQuery, useTheme } from '@mui/material';

export default function useCustomMediaQuery() {
  const mainTheme = useTheme();
  const tabletSizeAndLower = useMediaQuery(mainTheme.breakpoints.down('md'));

  return { isMobileTablet: tabletSizeAndLower };
}
